export default __webpack_public_path__ + "static/media/banner2.da1dec43.jpg";